import { AccountConfigService } from './../../services/account-config/account-config.service';
import { AuthService } from './../../../auth/services/auth/auth.service';
import { Component, forwardRef, Inject, OnInit, HostBinding } from '@angular/core';
import { DevisService } from '../../services/devis/devis.service';
import { MGridSettings, MUser } from '@argalis-apps/models';
import { DocumentService } from '../../services/document/document.service';
import config from './devis-list.config';

@Component({
  selector: 'ags-devis-list',
  templateUrl: './devis-list.component.html',
  styleUrls: ['./devis-list.component.scss']
})
export class DevisListComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  private userConnected: MUser.CUser = null;
  public propositionList: any[] = [];
  public gridSettings: MGridSettings.IGridSettings = config;
  public kendogridlistColumnsname: any[] = [
    {
      field: 'statut',
      title: 'Statut'
    },
    {
      field: 'code',
      title: 'Référence'
    },
    {
      field: 'dateReception',
      title: 'Date de réception'
    },
    {
      field: 'dateValiditeFinOffre',
      title: 'Fin de validité'
    },
    {
      field: 'prix',
      title: 'Prix (€)'
    },
    {
      field: 'docGenerated',
      title: ''
    }
  ];

  constructor(
    @Inject(forwardRef(() => AuthService)) private authService: AuthService,
    public devisService: DevisService,
    public documentService: DocumentService,
    private accountConfigService: AccountConfigService
  ) {
    this.userConnected = this.authService.userConnected;
    this.authService.userChange.subscribe((user: MUser.CUser) => {
      if (user && !user.login) this.userConnected = null;
      else this.userConnected = Object.assign({}, user);
    });
  }

  ngOnInit() {
    this.getDevis();
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
  }

  getDevis() {
    let idClient: number;
    if (this.userConnected) {
      idClient = Number(this.userConnected.company.id || 0);
    }
    //idClient = 33; // id de test; + extranet: false dans les params pour les tests
    if (!idClient || idClient === 0) return;
    this.devisService.getListByIdClient(idClient).subscribe(
      (list: any[]) => {
        if (list) {
          this.propositionList = list;
        }
      },
      () => {
        this.propositionList = [];
      }
    );
  }
}
